import getMuiTheme from 'material-ui/styles/getMuiTheme';

//Default Palette: https://github.com/callemall/material-ui/blob/master/src/styles/baseThemes/lightBaseTheme.js
//Default Theme: https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js

const theme = getMuiTheme({
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: "#09f",
    primary2Color: "#3c9",
    primary3Color: "#66f",
    accent1Color: "#f63",
    accent2Color: "#f93",
    nonUniqueColor: "#c233ff",
    accent3Color: "#08C",
    textColor: "#494949",
    secondaryTextColor: "#7f8492",
    // alternateTextColor: white,
    // canvasColor: white,
    borderColor: "#c1c7d4",
    infoBadgeColor: "#F41E30"
    // disabledColor: fade(darkBlack, 0.3),
    // pickerHeaderColor: cyan500,
    // clockCircleColor: fade(darkBlack, 0.07),
    // shadowColor: fullBlack
  },
  tableHeaderColumn: {
    height: 44,
    spacing: 8
  },
  tableRow: {
    height: 32,
    selectedColor: "#efefef"
  },
  tableRowColumn: {
    height: 32,
    spacing: 8
  }
});

export default theme;
